export default __webpack_public_path__ + "static/media/shadow-bright-winter.da71898c.png";